import { Link } from 'react-router-dom'
import { useState } from 'react'
import { Tooltip } from 'shared/ui'
import { logger } from 'shared/lib'
import { AIAgent } from 'icons/custom'
import { AiCallingApi } from 'entities/AICalling/api/aiCallingApi'
import styles from './styles.module.scss'

export const AICallingLabel = ({ id }: { id: string | number }) => {
  const [hover, setHover] = useState(false)
  const [loading, setLoading] = useState(false)
  const [nameMap, setNameMap] = useState<Record<string, string>>({})

  const name = nameMap[id]

  const onMouseEnter = async () => {
    setHover(true)
    if (loading) return
    if (!name) {
      try {
        setLoading(true)
        const { data } = await AiCallingApi.getById(Number(id))
        setNameMap((prevState) => ({ ...prevState, [id]: data.name }))
      } catch (err) {
        logger.error(err)
      } finally {
        setLoading(false)
      }
    }
  }

  return (
    <Tooltip label={name} placement='top' open={hover || undefined}>
      <Link to={`/chatbot/calling/view/${id}`} target={'_blank'}>
        <div
          className={styles.label}
          aria-label={'AICallingLabel'}
          onMouseEnter={onMouseEnter}
          onMouseLeave={() => setHover(false)}
        >
          <AIAgent />
        </div>
      </Link>
    </Tooltip>
  )
}
